import PlatinumCoinSvg from './PlatinumCoinSvg';

export default PlatinumCoinSvg;

export { PlatinumCoinSvg };
